export const EMPLOYER_TYPE_HOSPITAL = 'hospital';
export const EMPLOYER_TYPE_AIRFORCE = 'airforce';
export const EMPLOYER_TYPE_SENIOR = 'senior';
export const EMPLOYER_TYPE_MED_RECRUITER = 'med_recruiter';
